export default {
  questions: {
    openConversational: {
      openEndPlaceholder: "कृपया यहां अपना उत्तर दर्ज करें",
      conversationalPlaceholder: "कृपया यहां अपना उत्तर दर्ज करें",
      conversationClosed: "बातचीत बंद हो गई।",
      conversationalDisclaimer: "अनुवर्ती प्रश्न आपकी प्रतिक्रियाओं के आधार पर AI द्वारा उत्पन्न किए जाएंगे।"
    },
    openText: {
      openEndPlaceholder: "कृपया यहां अपना उत्तर दर्ज करें"
    },
    multiText: {
      fieldPlaceholder: 'उत्तर {number}',
      instruction: 'नीचे कम से कम {count} उत्तर टाइप करें, हर टेक्स्ट बॉक्स में एक',
      instructionWithoutMinimum: 'नीचे अपने उत्तर टाइप करें, हर टेक्स्ट बॉक्स में एक',
      minimumEntries: 'कृपया आगे बढ़ने के लिए कम से कम {count} उत्तर दर्ज करें।',
      unaidedBrandAwareness: {
        fieldPlaceholder: 'ब्रांड {number}',
        minimumEntries: 'कृपया आगे बढ़ने के लिए कम से कम {count} ब्रांड दर्ज करें।'
      }
    },
    multiselect: {
      caption: "सभी उपयुक्त विकल्प चुनें"
    },
    rankOrder: {
      enterRankOrder: "क्रम दर्ज करें",
      placeholder: "अपनी पसंद को क्रमबद्ध करने के लिए यहां खींचें"
    },
    openNumeric: {
      label: "खुला संख्यात्मक"
    },
    complete: {
      message: "इस सर्वेक्षण को पूरा करने के लिए धन्यवाद।"
    },
    openVideo: {
      warning: "कृपया आगे बढ़ने से पहले एक वीडियो रिकॉर्ड करें।",
      uploadStatusUploading: "कृपया जारी रखने के लिए तब तक प्रतीक्षा करें जब तक हम आपका वीडियो संसाधित नहीं कर लेते...",
      uploadStatusSuccess: "अपलोड सफल हुआ, आप आगे बढ़ सकते हैं.",
      uploadStatusError: "अपलोड पूरा नहीं हुआ, कृपया पुनः प्रयास करें."
    }
  },
  errors: {
    node: {
      text_invalid_email: 'कृपया एक मान्य ईमेल दर्ज करें',
      text_invalid_phone: 'कृपया एक मान्य फ़ोन नंबर दर्ज करें',
      text_invalid_us_zip: 'कृपया एक मान्य अमेरिकी ज़िप कोड दर्ज करें',
      text_invalid_ca_postal: 'कृपया एक मान्य कनाडाई पोस्टल कोड दर्ज करें',
      text_invalid_uk_postal: 'कृपया एक मान्य यूके पोस्टल कोड दर्ज करें',
      text_invalid_custom: 'कृपया मान्य {fieldName} दर्ज करें',
      text_min_chars: 'कृपया कम से कम {min} अक्षर दर्ज करें',
      text_max_chars: 'कृपया {max} अक्षरों से अधिक न दर्ज करें',
      text_alpha_not_allowed: 'केवल अंक अनुमत हैं',
      text_numeric_not_allowed: 'केवल वर्णमाला अक्षर अनुमत हैं'
    },
    external: {
      invalid: 'इस प्रश्न का उत्तर मान्य नहीं है।',
      required: 'इस प्रश्न का उत्तर दिया जाना आवश्यक है।',
      singlechoice_required: 'आगे बढ़ने से पहले कृपया एक विकल्प चुनें।',
      numeric_required: 'आगे बढ़ने से पहले कृपया एक रेटिंग चुनें।',
      text_required: 'आगे बढ़ने से पहले कृपया एक उत्तर दर्ज करें।',
      bigtext_required: 'आगे बढ़ने से पहले कृपया एक उत्तर दर्ज करें।',
      singlechoiceother_incomplete: 'आगे बढ़ने से पहले कृपया एक उत्तर दर्ज करें।',
      multiselectother_incomplete: 'आगे बढ़ने से पहले कृपया एक उत्तर दर्ज करें।',
      numeric_invalid: 'आगे बढ़ने से पहले कृपया एक मान्य संख्या दर्ज करें।',
      radiogrid_required: 'आगे बढ़ने से पहले कृपया प्रत्येक पंक्ति के लिए एक विकल्प चुनें।',
      incomplete: 'जारी रखने से पहले कृपया यह प्रश्न पूरी तरह से कंप्लीट कर लें।',
      multiselect_min: 'कृपया आगे बढ़ने से पहले कम से कम {value} विकल्प चुनें।',
      multiselect_max: 'कृपया आगे बढ़ने से पहले {value} से अधिक विकल्प न चुनें।',
      multiselectother_min: 'कृपया आगे बढ़ने से पहले कम से कम {value} विकल्प चुनें।',
      multiselectother_max: 'कृपया आगे बढ़ने से पहले {value} से अधिक विकल्प न चुनें।',
      multiselectgrid_min: 'कृपया आगे बढ़ने से पहले प्रत्येक पंक्ति के लिए कम से कम {value} विकल्प चुनें।',
      multiselectgrid_max: 'कृपया आगे बढ़ने से पहले प्रत्येक पंक्ति के लिए {value} से अधिक विकल्प न चुनें।',
      rankorder_min: 'कृपया आगे बढ़ने से पहले कम से कम {value} आइटम को रैंक करें।',
      rankorder_max: 'कृपया आगे बढ़ने से पहले {value} से अधिक आइटम को रैंक न करें।'
    }
  }
}
